var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{ active: _vm.measureActive, measureActives: _vm.measureActives },on:{"click":_vm.toggleMeasure}},[_c('img',{attrs:{"src":"/static/images/celiang.png","alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }